"use client"
import { organizationConfig } from "config/navigation/organizationConfig"
import { useHypertune } from "lib/feature-flags/generated/hypertune.react"
import React from "react"

import NavLinkItem from "../components/NavLinkItem"

export const OrgNavigationLinks: React.FC<{ isLoading?: boolean }> = ({ isLoading }) => {
    const flags = useHypertune()

    const availableLinks = flags
        ? organizationConfig(flags.get().activeFeatures).filter((item) => item.showLink)
        : []

    return (
        <nav className='relative flex w-full flex-col items-start justify-start dark:text-gray-200'>
            {availableLinks.map((orgItem, i) => (
                <NavLinkItem item={orgItem} key={orgItem.path + i} />
            ))}
        </nav>
    )
}

export default React.memo(OrgNavigationLinks)
